import {
  ADMIN_CONTACT_CITY,
  ADMIN_CONTACT_PARTNER,
  ADMIN_CONTACT_SCHOOL
} from '../../constants/admin.contacts.constants';
import { SEARCH_FIELD_TYPES } from '../../constants/advanced.search.constants';
import permissionsService from '../../services/permissions/permissions.service';

export const ADMIN_CONTACTS_ADVANCED_SEARCH_RESOURCE = {
  key: 'ADMIN_CONTACTS_ADVANCED_SEARCH_RESOURCE',
  fields: [
    {
      name: 'firstName',
      label: 'Voornaam',
      type: SEARCH_FIELD_TYPES.TEXT,
      section: 'person'
    },
    {
      name: 'lastName',
      label: 'Achternaam',
      type: SEARCH_FIELD_TYPES.TEXT,
      section: 'person'
    },
    {
      name: 'email',
      label: 'E-mail',
      type: SEARCH_FIELD_TYPES.TEXT,
      section: 'person'
    },
    {
      name: 'phone',
      label: 'Telefoon',
      type: SEARCH_FIELD_TYPES.TEXT,
      section: 'person'
    },
    {
      name: 'function',
      label: 'Functie',
      type: SEARCH_FIELD_TYPES.TEXT,
      section: 'person'
    },
    {
      name: 'type',
      label: 'Type',
      type: SEARCH_FIELD_TYPES.SINGLE_SELECT,
      dependency: 'contactTypes',
      fieldProps: {
        disableSearch: true
      },
      getIsVisible: (_filters, user) =>
        permissionsService.isPartnerEmployee(user) || permissionsService.isCityEmployee(user),
      section: 'type'
    },
    {
      name: 'roles',
      label: 'Rechten',
      type: SEARCH_FIELD_TYPES.MULTIPLE_SELECT,
      dependency: 'roles',
      section: 'type',
      fieldProps: {
        disableSearch: true
      },
      getIsVisible: (filters, user) =>
        [ADMIN_CONTACT_SCHOOL, ADMIN_CONTACT_CITY, ADMIN_CONTACT_PARTNER].includes(filters?.type) ||
        (permissionsService.isSchoolEmployee(user) &&
          !permissionsService.isPartnerEmployee(user) &&
          !permissionsService.isCityEmployee(user)),
      breakAfter: true
    },
    {
      name: 'net',
      label: 'Schoolnet',
      type: SEARCH_FIELD_TYPES.MULTIPLE_SELECT,
      dependency: 'schoolNets',
      section: 'type',
      getIsVisible: (filters, user) =>
        filters?.type === ADMIN_CONTACT_SCHOOL ||
        (permissionsService.isSchoolEmployee(user) &&
          !permissionsService.isPartnerEmployee(user) &&
          !permissionsService.isCityEmployee(user))
    },
    {
      name: 'management',
      label: 'Schoolbestuur',
      type: SEARCH_FIELD_TYPES.MULTIPLE_SELECT,
      dependency: 'schoolManagements',
      section: 'type',
      getIsVisible: (filters, user) =>
        filters?.type === ADMIN_CONTACT_SCHOOL ||
        (permissionsService.isSchoolEmployee(user) &&
          !permissionsService.isPartnerEmployee(user) &&
          !permissionsService.isCityEmployee(user))
    },
    {
      name: 'community',
      label: 'Schoolgemeenschap',
      type: SEARCH_FIELD_TYPES.MULTIPLE_SELECT,
      dependency: 'schoolCommunities',
      section: 'type',
      getIsVisible: (filters, user) =>
        filters?.type === ADMIN_CONTACT_SCHOOL ||
        (permissionsService.isSchoolEmployee(user) &&
          !permissionsService.isPartnerEmployee(user) &&
          !permissionsService.isCityEmployee(user))
    },
    {
      name: 'school',
      label: 'School',
      type: SEARCH_FIELD_TYPES.MULTIPLE_SELECT,
      dependency: 'schools',
      section: 'type',
      getIsVisible: (filters, user) =>
        filters?.type === ADMIN_CONTACT_SCHOOL ||
        (permissionsService.isSchoolEmployee(user) &&
          !permissionsService.isPartnerEmployee(user) &&
          !permissionsService.isCityEmployee(user))
    },
    {
      name: 'branch',
      label: 'Vestiging',
      type: SEARCH_FIELD_TYPES.MULTIPLE_SELECT,
      dependency: 'branches',
      section: 'type',
      getIsVisible: (filters, user) =>
        filters?.type === ADMIN_CONTACT_SCHOOL ||
        (permissionsService.isSchoolEmployee(user) &&
          !permissionsService.isPartnerEmployee(user) &&
          !permissionsService.isCityEmployee(user))
    },
    {
      name: 'organization',
      label: 'Organisatie',
      type: SEARCH_FIELD_TYPES.MULTIPLE_SELECT,
      dependency: 'organizations',
      section: 'type',
      getIsVisible: (filters) => filters?.type === ADMIN_CONTACT_PARTNER
    }
  ],
  sections: [
    { name: 'person', label: 'Persoon' },
    { name: 'type', label: 'Type' }
  ]
};
